// src/context/CompareContext.js

import React, {
  createContext,
  useState,
  useContext,
  useEffect
} from "react";

import { useNavigate } from "react-router-dom";

const CompareContext = createContext();

export const CompareProvider = ({ children }) => {

  const [colleges, setColleges] = useState([]);

  // ✅ are we selecting 2nd college?
  const [compareMode, setCompareMode] = useState(false);

  const navigate = useNavigate();

  // Auto open compare page
  useEffect(() => {
    if (colleges.length === 2) {
      navigate("/compare");
      setCompareMode(false); // reset
    }
  }, [colleges, navigate]);

  // Add college
  const addCollege = (college) => {
    setColleges((prev) => {

      // no duplicates
      if (prev.find((c) => c.id === college.id)) {
        return prev;
      }

      // max 2
      if (prev.length >= 2) return prev;

      return [...prev, college];
    });
  };

  // Clear all
  const clearCompare = () => {
    setColleges([]);
    setCompareMode(false);
  };

  return (
    <CompareContext.Provider
      value={{
        colleges,
        addCollege,
        clearCompare,

        // new
        compareMode,
        setCompareMode,
      }}
    >
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => useContext(CompareContext);
